import { html, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./metric.css?inline";
import "@/components/icon";
import "@/components/featured-icon";
import "@/components/tooltip";

@customElement("eko-metric")
class Metric extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true, type: Boolean, attribute: "background-gradient" })
  backgroundGradient: boolean = false;
  @property({ reflect: true }) change?: string;
  @property({ reflect: true, attribute: "change-label" }) changeLabel?: string;
  @property({ reflect: true, attribute: "change-type" }) changeType?: "positive" | "negative" =
    "positive";
  @property({ reflect: true }) help?: string;
  @property({ reflect: true }) href?: string;
  @property({ reflect: true }) icon?: string;
  @property({ reflect: true }) label: string = "";
  @property({ reflect: true }) stat: string = "";

  render() {
    return html`
      ${this.href ? html`<a class="eko-metric__link" href=${this.href}></a>` : nothing}
      <div class="eko-metric">
        <div class="eko-metric__header">
          <div class="eko-metric__label-wrapper">
            <span class="eko-metric__label">${this.label}</span>
            ${this.help
              ? html`
                  <eko-tooltip arrow class="eko-metric__help">
                    <eko-icon name="help-circle" theme="weakest" size="md"></eko-icon>
                    <span slot="content">${this.help}</span>
                  </eko-tooltip>
                `
              : nothing}
          </div>
          ${this.icon
            ? html`
                <eko-featured-icon
                  class="eko-metric__icon"
                  icon=${this.icon}
                  theme="neutral"
                  variant="square-light"
                  size="sm"></eko-featured-icon>
              `
            : nothing}
        </div>
        <div class="eko-metric__value-wrapper">
          <span class="eko-metric__value">
            <slot name="stat">${this.stat}</slot>
          </span>
          <slot name="value-append" class="eko-metric__value-append"></slot>
          <slot name="supporting" class="eko-metric__supporting"></slot>
        </div>
        ${this.change
          ? html`
              <div class="eko-metric__change">
                <eko-icon
                  class="eko-metric__change-icon"
                  name=${this.changeType === "positive" ? "trend-up-01" : "trend-down-01"}
                  size="md"></eko-icon>
                <span class="eko-metric__change-value">${this.change}</span>
                ${this.changeLabel
                  ? html`<span class="eko-metric__change-label">${this.changeLabel}</span>`
                  : nothing}
              </div>
            `
          : nothing}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-metric": Metric;
  }
}

export default Metric;
